/**
 * QA 폼 제출을 담당하는 커스텀 훅
 * @param {string} qaInput - QA 입력값
 * @param {boolean} qaLoading - QA 로딩 상태
 * @param {function} handleQaSend - QA 전송 함수
 * @returns {object} - 폼 제출 관련 함수들
 */
export const useQAForm = (qaInput, qaLoading, handleQaSend) => {
  /**
   * 폼 제출 핸들러
   * @param {Event} e - 폼 이벤트
   */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (qaInput.trim() && !qaLoading) {
      handleQaSend(qaInput);
    }
  };

  return {
    handleSubmit
  };
}; 